import { Article, Category, Translation } from '@wix/answers-api';
import { Box } from '@wix/design-system';
import classNames from 'classnames';
import React, { FunctionComponent, useMemo } from 'react';

import { ArticleSearchResult, PageType } from '../../types';
import { useStore } from '../../zustand/stores';
import { AgentToolbar } from '../AgentToolbar';
import { PageView } from '../PageView';
import { SEO } from '../SEO';
import { UserEngagement } from '../UserEngagement';

import css from './index.module.scss';

export type PageDataArticle = Article & {
  withRelatedArticles?: boolean;
};

export type PageData = {
  article?: PageDataArticle;
  category?: Category;
  translations?: Translation[];
  searchResults?: ArticleSearchResult;
  term?: string;
  categoriesTree?: Category[];
};

type PageTemplateProps = {
  children: React.ReactNode;
  pageType: PageType;
};

export const PageTemplate: FunctionComponent<PageTemplateProps> = ({
  children,
  pageType,
}) => {
  const { itemId, itemType, searchResults, term } = useStore(
    (state) => state.pageSlice
  );
  const { article, translations: articleTranslations } = useStore(
    (state) => state.articleSlice
  );
  const { category, translations: categoryTranslations } = useStore(
    (state) => state.categorySlice
  );
  const categoriesTree = useStore(
    (state) => state.categoriesTreeSlice.categoriesTree
  );

  const pageData: PageData = useMemo(
    () => ({
      article,
      category,
      categoriesTree,
      translations: articleTranslations || categoryTranslations,
      searchResults,
      term,
    }),
    [
      article,
      category,
      categoriesTree,
      articleTranslations,
      categoryTranslations,
      searchResults,
      term,
    ]
  );

  return (
    <Box
      direction="vertical"
      className={classNames('page-template', css.wrapper)}
    >
      <SEO pageData={pageData} pageType={pageType} />
      <AgentToolbar pageData={pageData} pageType={pageType} />
      <UserEngagement
        pageData={pageData}
        pageType={pageType}
        itemType={itemType as string}
        itemId={itemId}
      />
      <PageView pageData={pageData} pageType={pageType} itemId={itemId} />
      <main>{children}</main>
    </Box>
  );
};
